import React from "react";
import { Button } from "../../../ui/button";
import { useNavigate } from "react-router-dom";
import AudioPlayer from "./Audioplayer-error";
import Image from "../../../Tags/Image";
import { useTheme } from "../../../ThemeProvider";

export default function TranscriptionLoadingView({ recordingUrl, callMetadata }) {
  const navigate = useNavigate();
  const { theme } = useTheme();
  return (
    <div className=" mx-auto mt-6">
      <div>
        {/* Audio Player */}
        <AudioPlayer audioUrl={recordingUrl} callMetadata={callMetadata} />
        {/* No Analysis Available Message */}
        <div className="text-center py-12">
          <div className="illustration mb-6">
            <div className="flex justify-center">
              <div className="relative">
                <div className="flex items-center justify-center">
                  {theme === "dark" ? (
                    <Image
                      src="/images/icons/untitledui/number-inventory/no-transcription-dark.svg"
                      alt="No analysis available"
                      width={240}
                      height={240}
                      className="no-invert"
                    />
                  ) : (
                    <Image
                      src="/images/icons/untitledui/number-inventory/no-transcription-found.svg"
                      alt="No analysis available"
                      width={240}
                      height={240}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <h3 className="text-lg font-medium text-[#414651] dark:text-white mb-2">
            We’re transcribing your call, this might take upto 30 minutes after a call
          </h3>
        </div>
      </div>
    </div>
  );
}
